import {
  compose,
  withPropsOnChange,
  branch,
} from 'recompose'
import { connect } from 'react-redux'
import { getFormValues, change } from 'redux-form'

import * as R from 'ramda'
import get from 'lodash/get'

import { esuzStatusesTransport } from './esuzStatusesTransport'
import { esuzIssueTransport } from './esuzIssueTransport'
import prepareEsuzIssueForWidget from './prepareEsuzIssueForWidget'
import { withEquipment, equipmentDataPropName } from '../../EquipmentFormatter'

const withEsuzIssueOnForm = compose(
  esuzStatusesTransport,
  connect((state, { form }) => ({
    esuzIssueId: get(getFormValues(form)(state), `esuz`),
  }),
  (dispatch, { form }) => ({
    changeFormValue: (field, value) => dispatch(change(form, field, value)),
  })),
  branch(
    ({ esuzIssueId }) => esuzIssueId,
    esuzIssueTransport,
  ),
  withPropsOnChange([`esuzIssues`, `esuzStatuses`], ({ setIssueLinkData, esuzIssues, esuzStatuses }) => {
    if (!R.isEmpty(esuzIssues) && !R.isEmpty(esuzStatuses)) {
      const tempIssue = R.head(prepareEsuzIssueForWidget(esuzIssues, esuzStatuses))
      setIssueLinkData(tempIssue)
    } else {
      setIssueLinkData({})
    }
  }),
  withPropsOnChange([`issueLink`], ({ issueLink }) => {
    const entityId = R.path([`supplyPointCode`, 0, `key`], issueLink)

    return {
      entityId,
      errorComponent: () => entityId || `Нет данных`,
    }
  }),
  branch(
    ({ entityId }) => entityId,
    compose(
      withEquipment,
      withPropsOnChange([equipmentDataPropName], ({ [equipmentDataPropName]: equipment, changeFormValue }) => {
        const objectId = R.prop(`code`, equipment)
        const object = R.prop(`info`, equipment)
        changeFormValue(`objectId`, objectId)
        changeFormValue(`object`, object)
      }),
    ),
  ),
)

export default withEsuzIssueOnForm
